import React, { useContext } from 'react';
import './consejoEstudiantil.scss';
import AboutusDepartmentsContext from '../../../../../../../contexts/pages/aboutus/departments/departmentsContext';
import { FaUserGraduate, FaUsers, FaAward } from 'react-icons/fa';
import { baseURL } from '../../../../../../../api';

const DEFAULT_PRESIDENTES = [
    { grado: '1ro de Secundaria', cursoKey: 'Primero', presidente: 'Presidente 1er Grado', seccion: 'Secundaria' },
    { grado: '2do de Secundaria', cursoKey: 'Segundo', presidente: 'Presidente 2do Grado', seccion: 'Secundaria' },
    { grado: '3ro de Secundaria', cursoKey: 'Tercero', presidente: 'Presidente 3er Grado', seccion: 'Secundaria' },
    { grado: '4to de Secundaria', cursoKey: 'Cuarto', presidente: 'Presidente 4to Grado', seccion: 'Secundaria' },
    { grado: '5to de Secundaria', cursoKey: 'Quinto', presidente: 'Presidente 5to Grado', seccion: 'Secundaria' },
    { grado: '6to de Secundaria', cursoKey: 'Sexto', presidente: 'Presidente 6to Grado', seccion: 'Secundaria' },
];

const ConsejoEstudiantil = () => {
    const { studentsBoard } = useContext(AboutusDepartmentsContext);

    // Descripción institucional desde Strapi o fallback
    const descripcion = studentsBoard?.descripcion || `
Está conformado por los 6 presidentes de grado de secundaria (1ro a 6to). Garantiza la participación activa del estudiantado en la dinámica escolar, promoviendo el diálogo, la empatía y la representación de la comunidad estudiantil. La directiva se elige mediante elecciones democráticas anuales.
    `;

    // Resolver lista de presidentes desde Strapi
    // 1. Si existe lista específica de presidentes_grado o tarjetas_personal
    // 2. Si existe tabla_consejo_estudiantil tradicional de Strapi con Presidente asignado
    const tablaStrapi = studentsBoard?.tabla_consejo_estudiantil || [];
    const presidentesStrapi = studentsBoard?.presidentes_grado || studentsBoard?.tarjetas_personal || [];

    const presidentesList = DEFAULT_PRESIDENTES.map((item, index) => {
        // Buscar en presidentes_grado o tarjetas_personal si existe
        if (presidentesStrapi.length > 0 && presidentesStrapi[index]) {
            const p = presidentesStrapi[index];
            return {
                grado: p.grado || p.curso || item.grado,
                presidente: p.nombre || p.presidente || item.presidente,
                foto: p.foto?.[0]?.url || p.foto?.url || null,
            };
        }

        // Buscar en la tabla por curso que tenga un Presidente con texto válido
        const match = tablaStrapi.find(row => 
            row.curso && 
            row.curso.toLowerCase().includes(item.cursoKey.toLowerCase()) &&
            row.Presidente && 
            row.Presidente.trim() !== ''
        );

        if (match) {
            return {
                grado: item.grado,
                presidente: match.Presidente.trim(),
                foto: match.foto?.[0]?.url || match.foto?.url || null,
            };
        }

        return {
            grado: item.grado,
            presidente: item.presidente,
            foto: null,
        };
    });

    return (
        <section className="consejo-estudiantil-container">
            <div className="consejo-estudiantil-inner">
                {/* Header de la Sección estilo institucional */}
                <div className="consejo-header">
                    <div className="academic-board-title">CONSEJO ESTUDIANTIL</div>
                    <div className="academic-board-text">
                        <p>{descripcion}</p>
                    </div>
                </div>

                {/* Grid Moderno de los 6 Presidentes de Grado */}
                <div className="presidentes-grid">
                    {presidentesList.map((item, idx) => {
                        const fotoUrl = item.foto 
                            ? (item.foto.startsWith('http') ? item.foto : `${baseURL}${item.foto}`) 
                            : null;

                        return (
                            <article key={idx} className="presidente-card">
                                <div className="card-top-accent"></div>
                                <div className="card-body">
                                    {/* Chip con el Grado */}
                                    <div className="grado-badge">
                                        <FaAward className="grado-icon" />
                                        <span>{item.grado}</span>
                                    </div>

                                    {/* Avatar o Foto */}
                                    <div className="avatar-wrapper">
                                        {fotoUrl ? (
                                            <img
                                                src={fotoUrl}
                                                alt={`Presidente ${item.grado}`}
                                                className="avatar-photo"
                                            />
                                        ) : (
                                            <div className="avatar-placeholder">
                                                <FaUserGraduate className="avatar-icon" />
                                            </div>
                                        )}
                                        <div className="avatar-ring"></div>
                                    </div>

                                    {/* Información del Presidente */}
                                    <div className="presidente-info">
                                        <span className="cargo-label">Presidente de Grado</span>
                                        <h3 className="presidente-name">{item.presidente}</h3>
                                        <div className="badge-periodo">
                                            <span>Periodo Escolar</span>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ConsejoEstudiantil;